import { post } from '@/utils/request'

/**
 * 淘客的cms会员列表 
 * @param {String} telephone		        账号（电话）
 * @param {String} nickname	                昵称 
 * @param {String} pid	                    pid 
 * @param {String} lock	                    状态 0 未锁定 1锁定 不传是全部
 * @param {String} is_agent	                角色 0 是普通会员 1是代理 不传是全部  
 * @param {String} parent_cms_member_id	    指定推荐用户id
 * @param {String} page	                    页码
 * @param {String} pagesize	                分页大小 
 */
export function taoke_cms_member_list(data) {
  return post('taoke_cms_member_list', data)
}

/**
 * 淘客CMS会员信息设置
 * 
 * @param {String} cms_member_id        需要设置CMS会员ID，请注意必须是自己cms的会员
 * @param {String} alias_name           别名 
 * @param {String} pid                  pid（mm_xxxx_xxx_xxx），可以传入空字符串取消代理资格 
 * @param {String} order_start_time     订单开始计算时间 YYYY-MM-DD HH:NN:SS 
 */
export function taoke_cms_member_set(data) {
  return post('taoke_cms_member_set', data, {
    clear: false,
  })
}

/**
 * 淘客CMS会员封禁  
 * 
 * @param {String} cms_member_id        需要设置CMS会员ID，请注意必须是自己cms的会员
 * @param {String} lock                 封锁状态 0 解封 1封锁 
 */
export function taoke_cms_member_block(data) {
  return post('taoke_cms_member_block', data)
}

/**
 * 淘客CMS会员密码重置（随机） 
 * 
 * @param {String} cms_member_id        需要设置CMS会员ID，请注意必须是自己cms的会员
 */
export function taoke_cms_member_password_reset(data) {
  return post('taoke_cms_member_password_reset', data)
}

/**
 * 淘客CMS会员发送代理邀请 
 * 
 * @param {String} tsid	                tsid
 * @param {String} cms_member_id        需要设置CMS会员ID，请注意必须是自己cms的会员	
 */
export function taoke_cms_member_invite_agent(data) {
  return post('taoke_cms_member_invite_agent', data)
}

/**
 * CMS会员订单后六码绑定 
 * 
 * @param {String} tsid	                tsid
 * @param {String} member_id            会员id
 * @param {String} last_6_trade_id      订单后6位	
 */
export function taoke_last_6_trade_id_bind(data) {
  return post('taoke_last_6_trade_id_bind', data)
}
